// extracted by mini-css-extract-plugin
export default {"CheckableGroup":"CheckableGroup--ymJWY","CheckableGroup__label":"CheckableGroup__label--anRiu","CheckableGroup__content":"CheckableGroup__content--sT_V4"};